import { CueAnalytics, getTestEnvironmentName } from '@cuemath/analytics-v2';
import mixPanelPlugin from '@cuemath/analytics-v2/plugin-mixpanel';
import webengagePlugin from '@cuemath/analytics-v2/plugin-webengage';
import SharedWorker from '@cuemath/analytics-v2/shared-worker?sharedworker';
import Worker from '@cuemath/analytics-v2/worker?worker&inline';
import { WHITELIST_EVENTS } from '@cuemath/leap';
import {
  APP_ID,
  IS_DEV,
  IS_STAGING,
  MIXPANEL_TOKEN,
  SENTRY_DSN,
} from '@~/constants/app-config';
import { getDataFromLocalStorage } from '@~/utils';
import { getUserIdFromCookie } from '@~/utils/auth';

import { IS_DEBUG_MODE } from './constants';

const getEnvironment = () => {
  if (IS_DEV) {
    return 'DEVELOPMENT';
  }

  if (IS_STAGING) {
    return 'TESTING';
  }

  return 'PRODUCTION';
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getBaseURL = () => {
  if (IS_DEV) {
    return 'https://insightcollector.testenv10.cuemath.com/';
  }

  if (IS_STAGING) {
    return `https://insightcollector.${getTestEnvironmentName()}.cuemath.com`;
  }

  return 'https://insightcollector.cuemath.com';
};

const areCueLogsEnabled = () => {
  if (IS_DEV) return true;

  const isDebugMode = getDataFromLocalStorage(IS_DEBUG_MODE);

  return isDebugMode === true;
};

const getAppBuildNumber = () => {
  const buildNumber = Number(process.env.REACT_APP_BUILD_NUMBER) || 0;

  return buildNumber;
};

const analytics = new CueAnalytics({
  worker: window.SharedWorker ? new SharedWorker() : new Worker(),
  environment: getEnvironment(),
  sentryOptions: !IS_DEV
    ? {
        dsn: SENTRY_DSN,
        environment: IS_STAGING ? 'staging' : 'production',
        release: `${IS_STAGING ? 'staging' : 'production'}:${
          process.env.REACT_APP_SENTRY_RELEASE
        }`,
        userId: getUserIdFromCookie() ?? null,
      }
    : undefined,
  userType: 'STUDENT',
  appId: APP_ID,
  appVersion: '0.0.0',
  appBuildNumber: getAppBuildNumber(),
  logEnabled: areCueLogsEnabled(), // If true, This logs data in the console. Check inspect in browser.
  logLevel: 'info',
  plugins: [
    webengagePlugin({
      webengage: undefined,
      trackAllEvents: false,
    }),
    mixPanelPlugin({
      token: MIXPANEL_TOKEN,
      trackAllEvents: false,
      batchRequests: false,
      recordIdleTimeoutMs: 300000, // 5 minutes
      recordSessionsPercent: 0,
    }),
  ] as any,
  whitelistEvents: WHITELIST_EVENTS as any,
});

export default analytics;
